import { CSSProperties } from 'react';
import { styled } from '@mui/material';

export const Container = styled('div', {
	shouldForwardProp: (prop) => prop !== 'gap',
})<{ gap?: CSSProperties['gap'] }>(({ gap }) => ({
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	gap,
	'&.flexStart': {
		justifyContent: 'flex-start',
	},
	'&.flexEnd': {
		justifyContent: 'flex-end',
	},
	'&.center': {
		justifyContent: 'center',
	},
	'&.spaceBetween': {
		justifyContent: 'space-between',
	},
}));

export const ColumnContainer = styled('div', {
	shouldForwardProp: (prop) => !['gap', 'sx'].includes(prop as string),
})<{ gap?: CSSProperties['gap'] }>(({ theme, gap }) => ({
	display: 'flex',
	flexDirection: 'column',
	color: theme.palette.text.primary,
	gap,
	'&.flexStart': {
		alignItems: 'flex-start',
	},
	'&.flexEnd': {
		alignItems: 'flex-end',
	},
	'&.center': {
		alignItems: 'center',
	},
	'&.spaceBetween': {
		alignItems: 'space-between',
	},
}));
